import React from 'react';
import { useTranslation } from 'react-i18next';
import './Calendario.css';

interface CalendarioProps {
  selectedDate: Date;
  onDateChange: (date: Date) => void;  // Cambiado para aceptar un objeto Date
  publications: { date: string, status: 'published' | 'scheduled' }[];
}

const Calendario: React.FC<CalendarioProps> = ({ selectedDate, onDateChange, publications }) => {
  const { t, i18n } = useTranslation();

  const getDaysInMonth = (year: number, month: number) => {
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    return new Array(daysInMonth).fill('').map((_, i) => new Date(Date.UTC(year, month, i + 1)));
  };

  const getBlankDays = (year: number, month: number) => {
    const firstDayOfMonth = new Date(Date.UTC(year, month, 1)).getUTCDay();
    const blankDaysCount = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1;
    return new Array(blankDaysCount).fill('');
  };

  const getStatusesForDate = (date: Date) => {
    const formattedDate = date.toISOString().split('T')[0];
    return publications.filter(pub => pub.date.split('T')[0] === formattedDate).map(pub => pub.status);
  };

  console.log(publications);

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const daysOfWeek = ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'];
  const days = getDaysInMonth(selectedDate.getUTCFullYear(), selectedDate.getUTCMonth());
  const blankDays = getBlankDays(selectedDate.getUTCFullYear(), selectedDate.getUTCMonth());

  const nextMonth = () => {
    const nextMonthDate = new Date(Date.UTC(selectedDate.getUTCFullYear(), selectedDate.getUTCMonth() + 1, 1));
    onDateChange(nextMonthDate);
  };

  const prevMonth = () => {
    const prevMonthDate = new Date(Date.UTC(selectedDate.getUTCFullYear(), selectedDate.getUTCMonth() - 1, 1));
    onDateChange(prevMonthDate);
  };

  const handleDateSelect = (date: Date) => {
    onDateChange(date);
  };

  return (
    <div className="calendario-container">
      <div className="calendario-header">
        <button onClick={prevMonth}>&lt;</button>
        <span className="calendario-month">
          {selectedDate.toLocaleString(i18n.language, { month: 'long' })} {selectedDate.getUTCFullYear()}
        </span>
        <button onClick={nextMonth}>&gt;</button>
      </div>
      <div className="grid-container">
        {daysOfWeek.map(day => (
          <div key={day} className="grid-day">{t(`${day}`)}</div>
        ))}
        {blankDays.map((_, i) => (
          <div key={`blank-${i}`} className="grid-date"></div>
        ))}
        {days.map(day => {
          const statuses = getStatusesForDate(day);
          let className = "grid-date";
          if (statuses.includes('published') && statuses.includes('scheduled')) {
            className += " both";
          } else if (statuses.includes('published')) {
            className += " publicado";
          } else if (statuses.includes('scheduled')) {
            className += " programado";
          }
          return (
            <div
              key={day.toISOString()}
              className={className}
              onClick={() => handleDateSelect(day)}
            >
              {day.getUTCDate()}
            </div>
          );
        })}
      </div>
      <div className="legend">
        <div className="legend-item">
          <span className="legend-color publicado"></span>
          <span>{t('Publicado')}</span>
        </div>
        <div className="legend-item">
          <span className="legend-color programado"></span>
          <span>{t('Programado')}</span>
        </div>
        <div className="legend-item">
          <span className="legend-color both"></span>
          <span>{t('Publicando')}</span>
        </div>
      </div>
    </div>
  );
};

export default Calendario;
